/**
 * Key (and drag id) of the trailing "+" column. It isn't one of the user's
 * columns, so it can't be reordered and is never saved with the table settings.
 */
export const ADD_COLUMN_KEY = "add-column";
